import { DEFAULT_STATUS } from "@anaconda/core/nft/search/constants"
import {
  AVAILABLE_NFT_SORTS,
  RarityFilterOption,
  StatusFilterOption,
} from "@anaconda/core/nft/search/types"
import { z } from "zod"

export const SORT_VALIDATOR = z.enum(AVAILABLE_NFT_SORTS).optional()

const STATUS_VALIDATOR = z
  .nativeEnum(StatusFilterOption)
  .optional()
  .default(DEFAULT_STATUS)

const RARITY_VALIDATOR = z.nativeEnum(RarityFilterOption).optional()

const PRICE_VALIDATOR = z.number().optional()

const TRAITS_VALIDATOR = z
  .array(z.object({ key: z.string(), values: z.array(z.string()) }))
  .optional()

const FILTER_VALIDATOR = z.object({
  text: z.string().optional(),
  minPrice: PRICE_VALIDATOR,
  maxPrice: PRICE_VALIDATOR,
  status: STATUS_VALIDATOR,
  traits: TRAITS_VALIDATOR,
  rarity: RARITY_VALIDATOR,
})

export const SERIALIZED_FILTER_VALIDATOR = z
  .string()
  .optional()
  .refine((serializedFilter) => {
    if (!serializedFilter) return true

    try {
      const filter = deserializeObject(serializedFilter)
      FILTER_VALIDATOR.parse(filter)
      return true
    } catch (e) {
      return false
    }
  })
  .transform((serializedFilter) => {
    if (!serializedFilter) return { status: DEFAULT_STATUS }

    const filter = deserializeObject(serializedFilter)

    return FILTER_VALIDATOR.parse(filter)
  })

export const SEARCH_PARAMS_SCHEMA = z.object({
  sort: SORT_VALIDATOR,
  filters: SERIALIZED_FILTER_VALIDATOR,
})

const deserializeObject = (serialized: string) =>
  JSON.parse(decodeURIComponent(serialized))
